export default __webpack_public_path__ + "933010919c539a7ceaf319e2106f7a0c.svg";